import { getstalls, getbusinessdate, insertbusinessdate, putOpenTOInter, deletebusinessdate } from '@/api/time'
// import { getToken } from '@/utils/auth'
const state = {
}
const mutations = {

}

const actions = {
	getstalls ({ }, data) {
		return new Promise((resolve, reject) => {
			getstalls(data).then(res => {
				const obj = {
					records: res
				}
				resolve(obj)
			}).catch(error => {
				reject(error)
			})
		})
	},

	getbusinessdate ({ }, data) {
		return new Promise((resolve, reject) => {
			getbusinessdate(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},

	insertbusinessdate ({ }, data) {
		return new Promise((resolve, reject) => {
			insertbusinessdate(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},

	putOpenTOInter ({ }, data) {
		return new Promise((resolve, reject) => {
			putOpenTOInter(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},

	deletebusinessdate ({ }, data) {
		return new Promise((resolve, reject) => {
			deletebusinessdate(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
